module.exports = __webpack_public_path__ + "img/VBAA.935ab6ad.png";